export default class User {
    private _username: string = null;
    public status: string = null;
    private _userLinkName: string = null;

	constructor(username: string, status: string, userLinkName: string) {
        this._username = username;
        this.status = status;
        this._userLinkName = userLinkName ? userLinkName : '';
    }
    
    public get username() : string {
        return this._username;
    }

    public get userLinkName() : string {
	    return this._userLinkName;
    }
}